<template>
    <v-col cols="12">
        <span class="headline">Korisnici</span>
        <bit-page :breadcrumbs="breadcrumbs"></bit-page>
        <v-row align="center" class="white mt-3 pa-3" no-gutters>
            <span class="title green--text text--darken-3">Korisnici</span>
            <v-col class="d-flex mb-3" cols="12">
                <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
                <v-text-field
                        v-model="user.name"
                        dense
                        label="Naziv"
                        outlined
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
                <v-text-field
                        v-model="user.email"
                        dense
                        label="E-Mail"
                        outlined
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
                <v-text-field
                        v-model="user.password"
                        dense
                        outlined
                        type="password"
                        label="Lozinka"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" class="px-2">
                <v-select
                        chips
                        v-model="user.website"
                        :items="items"
                        label="Website"
                        outlined
                        multiple
                        return-object
                        item-text="website"
                        item-value="id"
                ></v-select>
            </v-col>
            <v-col cols="12">
                <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="mt-2">
                <v-row justify="center">
                    <v-btn color="primary" tile depressed @click="save">Snimi</v-btn>
                </v-row>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
	import bitPage from "../../components/layout/page";

	export default {
		components: {
			bitPage
		},
		head() {
			return {
				title: 'BitLab CMS'
			}
		},
		data: () => ({
			breadcrumbs: [
				{
					text: 'Korisnici',
					disabled: false,
					to: {name: 'korisnici'},
				},
				{
					text: 'Dodavanje novog korisnika',
					disabled: true
				},
			],
			headers: [
				{text: 'ID', value: 'id'},
				{text: 'Name', value: 'name'},
				{text: 'Code', value: 'code'},
				{text: 'Icon', value: 'icon'},
				{text: 'Option', value: 'option'}
			],
			items: [],
            user: {
			    name: null,
                email: null,
                password: null,
                website: []
            }
		}),
        created() {
            if(this.$route.params.item){
                this.user = this.$route.params.item;
            }
		    this.getWebsite();
        },
        methods: {
		    getWebsite() {
		        this.axios.get('/website').then(res => {
		            this.items = res.data
                })
            },
            save() {
                if(this.$route.params.item){
                    let data = {...this.user}
                    data.website = data.website.map(item => item.id)
                    this.axios.put(`/user/${data.id}`, data).then(res => {
                        console.log(res)
                    })
                }
                else{
                    let data = {...this.user}
                    data.website = data.website.map(item => item.id)
                    this.axios.post('/user', data).then(res => {
                        console.log(res)
                    })
                }
            }
        }
	}
</script>
